const WixUrl = () => import(/* webpackChunkName: "WixUrl" */ '@/components/Pages/IframeUrl')
const betaRegistration = () => import(/* webpackChunkName: "WixUrl" */ '@/components/Pages/LandingPage/ProjectBoard/BetaRegistration')

module.exports = [
  {
    path: '/makeprojects-home',
    beforeEnter () { location.href = 'https://makeprojects.com' },
    name: 'landingMake'
  },
  {
    path: '/projectboard-ysc',
    beforeEnter () { location.href = 'https://projectboard.world/ysc' },
    name: 'landingYsc'
  },
  {
    path: '/projectboard-isef',
    beforeEnter () { location.href = 'https://projectboard.world/isef' },
    name: 'landingIsef'
  },
  {
    path: '/makeprojects-edu',
    beforeEnter () { location.href = 'https://makeprojects.com/category/education' },
    name: 'landingEdu'
  },
  {
    path: '/stemevents',
    name: 'landingSteam',
    component: WixUrl
  },
  {
    path: '/schools',
    name: 'landingSchool',
    component: WixUrl
  },
  {
    path: '/engineering-home',
    beforeEnter () { location.href = 'https://www.engineering.com' },
    name: 'landingEngineering'
  },
  {
    path: '/about',
    name: 'landingAbout',
    component: WixUrl
  },
  {
    path: '/engineering-legal',
    beforeEnter () { location.href = 'https://www.engineering.com/legal' },
    name: 'landingLegal'
  },
  {
    path: '/:partner?/coming-soon',
    name: 'comingSoon',
    component: WixUrl
  },
  {
    path: '/beta-registration',
    name: 'betaRegistration',
    component: betaRegistration
  }
]
